<template>
  <div class="page">
    <h2>您好</h2>
    <h2>欢迎来到品胜</h2>
    <div class="input-item">
      <div class="input-layout">
        <div class="title">手机号</div>
        <input
          type="tel"
          name="phone"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="phone"
        />
      </div>
    </div>
    <div class="input-item">
      <div class="input-layout">
        <div class="title">验证码</div>
        <input
          placeholder="请输入验证码"
          v-model="verification"
          maxlength="8"
        />
      </div>
      <div class="line"></div>
      <button
        :class="'verification ' + (countdown ? 'countdown' : '')"
        :disabled="countdown > 0"
        @click="requestSmsCode"
      >
        {{ countdown ? countdown + " S" : "获取验证码" }}
      </button>
    </div>
    <div class="send-sms-info">{{ sendSmsInfo }}</div>
    <button class="submit" :disabled="!submitEnable" @click="submit">
      {{ submitText }}
    </button>
    <div class="agreement-select">
      <div class="check-c-box">
        <van-checkbox  v-model="isCheckAgreement" checked-color="#000" />
      </div>
      <div class="agreement-list">我已阅读并同意
        <span class="info-link" @click="goto('/sysAgreement?Module=用户协议')">《用户协议》</span>及
        <span class="info-link" @click="goto('/sysAgreement?Module=隐私协议')">《隐私协议》</span>，未注册的手机号将自动创建品胜账号
      </div>
    </div>
    <graph-dialog
      v-model="showGraph"
      :phone="phone"
      v-on:callback="getGraphCallBack"
    ></graph-dialog>
    <van-dialog v-model="agreementDialogQues" show-cancel-button confirmButtonText="同意" cancelButtonText="我再想想" @confirm="dialogSubmit">
      <p style="padding: 15px 0 0;">请阅读并同意 <span class="info-link">用户协议</span> 及 <span class="info-link">隐私协议</span>。</p>
    </van-dialog>
  </div>
</template>
<script>
import { httpUser } from "../../scripts/network";
import { USER_INFO } from "../../store/mutation-types";
import Vue from "vue";
import { Toast,Checkbox,Dialog   } from "vant";

const { publicPath } = process.env.CONFIG;

Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(Dialog)
export default {
  name: "authorization",
  data() {
    return {
      submitText: this.$route.query.type == "bindWechat" ? "绑定微信" : "登录",
      eulaUrl: publicPath + '/eula.html',
      phone: "",
      verification: "",
      sendSmsInfo: "",
      nextSendSmsTime: window.local.get("sms-countdown"),
      countdown: 0,
      showGraph: false,
      hander: {
        interval: null
      },
        isCheckAgreement:false,
        agreementDialogQues:false,
        subType:1
    };
  },
    computed:{
        submitEnable() {
            return this.verification && this.verification.length > 0;
        }
    },
  mounted() {
    this.checkCountdown();
  },
  beforeDestroy() {
    if (this.hander.interval) {
      clearInterval(this.hander.interval);
    }
  },
  methods: {
    requestSmsCode() {
      if (this.phone.length < 11) {
        Toast.fail("号码错误");
        return;
      }
        if(!this.isCheckAgreement){
            this.agreementDialogQues = true
            this.subType = 1
            return
        }
      this.showGraph = true;
    },
    getGraphCallBack(e) {
      if (e) {
        this.showGraph = e.dialog;
      }
      if (e.success) {
        this.sendSmsInfo = "短信验证码已发送至+86 " + this.phone;
        let next = new Date().getTime() + 60 * 1000;
        window.local.save("sms-countdown", next);
        this.nextSendSmsTime = next;
        this.checkCountdown();
      }
    },
      dialogSubmit(){
          this.isCheckAgreement = true
          if(this.subType == 1){
              this.showGraph = true;
          }
          if(this.subType == 2){
              this.submit()
          }
      },
    submit() {
        if(!this.isCheckAgreement){
            this.agreementDialogQues = true
            this.subType = 2
            return
        }
      if (this.$route.query.type == "bindWechat") {
        this.bindWechat();
      } else {
        this.login();
      }
    },
    async bindWechat() {
      try {
        const params = {
          type: "get",
          param: {
            Mobile: this.phone,
            SMSCode: this.verification,
            UnionId: this.$route.query.unionId,
            OpenId: this.$route.query.openId
          }
        };
        Toast.loading({ message: "正在绑定" });
        const ret = await httpUser("/User/BindUser", params);
        Toast.clear();
        this.saveLoginData(ret);
      } catch (e) {
        console.log(e);
        Toast.clear();
        Toast.fail(e);
      }
    },
    async login() {
      try {
        Toast.loading({ message: "正在登录" });
        let ret = await httpUser("/User/Login", {
          type: "POST",
          body: { Mobile: this.phone, SmsCode: this.verification }
        });
        Toast.clear();
        this.saveLoginData(ret);
        // console.log(ret);
      } catch (e) {
        console.log(e);
        Toast.clear();
        Toast.fail(e);
      }
    },
    saveLoginData(ret) {
      if (ret.Status) {
        window.local.saveValue("sessionKey", ret.Data.SessionKey);
        let userInfo = {
          avatar: ret.Data.HeadImgUrl,
          phone: ret.Data.User.LoginMobile,
          name:
            ret.Data.User.NickName ||
            ret.Data.User.RealName ||
            ret.Data.User.LoginMobile
        };
        this.$store.dispatch(USER_INFO, userInfo);
        console.log("====",this.$route.query.redirect
            ? JSON.parse(decodeURIComponent(this.$route.query.redirect))
            : "/care")
        this.$router.replace(
          this.$route.query.redirect
            ? JSON.parse(decodeURIComponent(this.$route.query.redirect))
            : "/care"
        );
      } else {
        Toast.fail(ret.Message);
      }
    },
    checkCountdown() {
      this.countdown = this.computedCountdown();
      if (this.countdown > 0) {
        this.hander.interval = setInterval(() => {
          this.countdown = this.computedCountdown();
          if (this.countdown < 0) {
            clearInterval(this.hander.interval);
          }
        }, 1000);
      }
    },
    computedCountdown() {
      let now = new Date().getTime();
      if (now < this.nextSendSmsTime) {
        let gap = this.nextSendSmsTime - now;
        return parseInt(gap / 1000);
      } else {
        return 0;
      }
    },
      showAgreementDialog(){

      }
  }
};
</script>
<style scoped>
.page {
  text-align: center;
  overflow: hidden;
  padding: 60px 40px 0 30px;
  box-sizing: border-box;
  height: 100vh;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

h2 + h2 {
  margin-top: 4px;
  margin-bottom: 45px;
}

.input-item {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  border-bottom: #e5e5e5 1px solid;
}

.input-item + .input-item {
  margin-top: 30px;
}

.input-layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}

input {
  font-size: 18px;
  height: 48px;
  line-height: 48px;
  font-weight: 400;
  width: 100%;
  letter-spacing: 2px;
  caret-color: #ff9c28;
}

.line {
  width: 1px;
  height: 26px;
  background: #e5e5e5;
  margin-bottom: 10px;
}

.verification {
  font-size: 14px;
  height: 48px;
  line-height: 48px;
  color: #ff7c3c;
  width: 90px;
  text-align: center;
  border: none;
  background: unset;
  padding: 0;
  margin: 0;
}

.countdown {
  color: #d1d1d1;
}

.send-sms-info {
  font-size: 10px;
  color: #999999;
  text-align: start;
  margin-top: 6px;
  height: 12px;
}

.submit {
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 18px;
  padding: 0;
  margin: 0;
  color: white;
  border: none;
  border-radius: 22px;
  background-image: linear-gradient(to right, #ff9c28, #ff7640);
  margin-top: 75px;
}

.submit:active {
  background-image: linear-gradient(to right, #fc8c0d, #fc6124);
}
.submit:disabled {
  background: #c6c6c6;
}

.info {
  font-size: 12px;
  margin-top: 16px;
  color: #666666;
}

.info-link {
  font-size: 14px;
  color: #ff8d40;
}
  .agreement-select{
    font-size: 14px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .agreement-select .agreement-list{
    margin-left: 12px;
  }
.van-dialog{
  font-size: 14px;
}
</style>
